import * as Sentry from '@sentry/browser';

var initSentry = function initSentry(sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    integrations: [new Sentry.Integrations.GlobalHandlers({
      onunhandledrejection: false
    })]
  });
  Sentry.setTag('logger', 'JavaScript');
  Sentry.setTag('module', 'PLTV v2');
  window.pltvSentry = Sentry;
};

export { initSentry };